import React from 'react';

export default class LabeledContainer extends React.Component {

  render() {
    const { children, title, row, className, beforeTitle, afterTitle } = this.props
    const STYLE = { display: 'flex',  flexDirection: row ? 'row' : 'column' }
    return (
      <div className={className} style={STYLE}>
        <label>{beforeTitle}{title}{afterTitle}</label>
        {children}
      </div>
    )
  }
}